import { useAppSelector } from 'shared';

export const useCateringEventFormatPageState = (
    () => useAppSelector((store) => store.cateringEventFormatPage)
);
